import React from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import data from "../../../package.json";
import isPWA from "../../helpers/isPWA";
import osName from '../../helpers/osName';
import osVersion from '../../helpers/osVersion';
import browserName from '../../helpers/browserName';

export default function Copyright() {

  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="http://reactblog.pl">
        zenGTD {isPWA && " (PWA) "}
        (v.{data.version}) - {new Date().getFullYear()}
        <br /> Hanus Commercial Arts <br />
        {browserName} - {osName} {osVersion}
      </Link>
    </Typography>
  );
}
